import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=1aca9894&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"
import style0 from "./Sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aca9894')) {
      api.createRecord('1aca9894', component.options)
    } else {
      api.reload('1aca9894', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=1aca9894&", function () {
      api.rerender('1aca9894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "auth_ui/static/vue-src/components/Sidebar.vue"
export default component.exports